import cloneDeep from 'lodash.clonedeep';
import * as http from '../Http';
import { buildPostRequest } from '../Http/requestTemplates';
import { settings } from '../helpers';

const TIMEOUT = 1500;

let __tracking_payloads: any[] = [];
let timeoutId: NodeJS.Timeout = 0 as unknown as NodeJS.Timeout;

const replaceEmpty = (obj: any) => (emptyAction: (a: any, b: string) => void) => {
  Object.keys(obj).forEach((key) => {
    if (obj[key] && Array.isArray(obj[key]) && !obj[key].length) {
      emptyAction(obj, key);
    } else if (obj[key] && typeof obj[key] === 'object') {
      replaceEmpty(obj[key])(emptyAction);
    } else if (!obj[key] || obj[key] === null) {
      emptyAction(obj, key);
    }
  });

  return obj;
};

const dataLayerTracker = (trackedEvents: any[]) => {
  if (window && window.dataLayer) {
    //undefined is desired by GA
    trackedEvents
      // eslint-disable-next-line no-undefined
      .map((payload) => replaceEmpty(payload)((obj, emptyKey) => (obj[emptyKey] = undefined)))
      .map((payload) => window.dataLayer?.push({ event: payload.eventType, data: payload }));
  }
};

const waykeAnalyticsTracker = (trackedEvents: any[]) => {
  const cleanedPayloads = trackedEvents.map((p) => replaceEmpty(p)((obj, key) => delete obj[key]));
  try {
    http.raw(settings.get('WaykeAnalyticsUri'), buildPostRequest(cleanedPayloads));
  } catch (_e) {
    // Silent catch failed tracking req
  }
};

const __trackers = [dataLayerTracker, waykeAnalyticsTracker];

const trackerHub = (payload: any) => {
  clearTimeout(timeoutId);

  timeoutId = setTimeout(() => {
    __trackers.forEach((tracker) => {
      const independentPayload = __tracking_payloads.map((p) => cloneDeep(p));
      tracker(independentPayload);
    });
    __tracking_payloads = [];
  }, TIMEOUT);

  __tracking_payloads.push(payload);
};

export const trackerHubInstant = (payload: any) => {
  clearTimeout(timeoutId);
  __tracking_payloads.push(payload);
  __trackers.forEach((tracker) => {
    const independentPayload = __tracking_payloads.map((p) => cloneDeep(p));
    tracker(independentPayload);
  });
  __tracking_payloads = [];
};

export default trackerHub;
